import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { BIReport } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import BIReportForm from '@/components/power-bi/BIReportForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditBIReport',
  props: {
    biReport: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const props = __props;

    const form = useForm({
        company_id: selectedCompanyId.value,
        bi_id: props.biReport.id,
        reporting_account: props.biReport.reporting_account,
        reporting_account_nr: props.biReport.reporting_account_nr,
        account_mapping: props.biReport.accounts_in_mapping,
        measurement_calculation: props.biReport.measurement_calculation,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.powerbi.setup.store'),
    method: "post",
    "query-key": [_unref(QueryKey).POWER_BI, selectedCompanyId.value],
    title: "bi_and_companies.edit_bi_row"
  }, {
    default: _withCtx(() => [
      _createVNode(BIReportForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})